export const IShareViewModelType = Symbol('IShareViewModel');
